module.exports = "../study/imgs/maps/Tokyo/S8/Helth/Mosquito/Tokyo_Mosquito_MIROC5_RCP26_Now.png";